module.exports = {"component":"pill","status":"prototype","display-name":"Pills","SLDS-component-path":"/components/pills","url-slug":"pills"}


//////////////////
// WEBPACK FOOTER
// ./components/pill/docs.json
// module id = 172
// module chunks = 0